module.exports = __webpack_public_path__ + "~@/assets/img/settings.35f6049a.png";